import { globalReactService } from '@commons'
import { getCookie } from './cookies.helper'
import jwtDecode from 'jwt-decode'

export const getJwtFromCookies = () => {
  let cookieKey = 'rankmi_jwt'
  const defaultSubDomain = globalReactService.defaultSubDomain

  try {
    cookieKey =
      defaultSubDomain && defaultSubDomain.match(/^app$/g)
        ? cookieKey
        : `rankmi_${defaultSubDomain}_jwt`
  } catch (error) {
    console.error(error)
  }
  return getCookie(cookieKey)
}

export const getValueFromJwt = (key: string) => {
  const jwt: Record<string, any> = jwtDecode(getJwtFromCookies())
  return jwt[key]
}
